<div class="modal-window recipients">

  <h3>Share output(s)</h3>

  <div class="modal-content">

    <p-tabView styleClass="strategies-tab-view" (onChange)="onTabChange()">
      <p-tabPanel [header]="EMAIL_HEADER" >
        <h5>Add one or more email addresses. Separate email addresses with semicolon (;)</h5>
        <p-chips [(ngModel)]="emails" (onAdd)="onEmailAdded()" styleClass="strategies-chips"
                 placeholder="Enter email address"> </p-chips>
        <h5>Emails available: {{ emailsAvailable }}</h5>
      </p-tabPanel>
      <p-tabPanel [header]="WORKSPACE_HEADER">
        <h5>Select a single eProve&trade; workspace</h5>
        <div class="workspace-scroll">
          <ng-container *ngFor="let workspace of workspaces">
            <div class="workspace-card" [ngClass]="{'card-selected': workspace === selectedWorkspace }"
                 (click)="onWorkspaceClick(workspace)">
              {{ workspace.workspaceName }}
              <span *ngIf="workspace.startDate || workspace.endDate">
                <span
                  *ngIf="workspace.startDate; else noStartDate">({{ workspace.startDate | date:'yyyy-MM-dd' }}</span>
                <ng-template #noStartDate><span class="no-date-span">(</span></ng-template> -
                <span *ngIf="workspace.endDate; else noEndDate">{{ workspace.endDate | date:'yyyy-MM-dd'}})</span>
                <ng-template #noEndDate><span class="no-date-span"></span>)</ng-template>
              </span>
              <br/>
              <div class='last-shared-date' *ngIf="workspace.lastSharedDate">
                Last Shared To This Workspace: {{ workspace.lastSharedDate | date:'yyyy-MM-dd' }}
              </div>
              {{ workspace.institutionName }} <br/>
              {{ workspace.institutionLocation.city }},
              {{ workspace.institutionLocation.state }},
              {{ workspace.institutionLocation.country }}
            </div>
          </ng-container>
          <div *ngIf='workspaces.length === 0'>
            <p>A review is not associated with your institution.</p>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>

    <div class="button-error-row">
      <div class="error-cell">
        <div *ngIf="emailIsInvalid">You must enter a valid email address. Try again.</div>
        <div *ngIf="maxEmailLimit">Max of {{ MAX_EMAIL_RECIPIENTS }} recipients allowed.</div>
        <div *ngIf="workspaceNotSelected">Please select a workspace to share to.</div>
        <div *ngIf="noEmailsEntered">Please enter an email to share to.</div>
      </div>
      <div class="button-cell">
        <input type="button" class="btn btn-alt left-btn btn-strategy-map" (click)="onHideModalClick()"
               value="Cancel"/>
        <input type="button" class="btn btn-strategy-map smd-btn" (click)="onClickDownloadButton()" value="Send">
      </div>
    </div>
  </div>
</div>
